import { ResponsePanelController } from '../controller/ResponsePanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class ResponsePanelWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ResponsePanelController,
    });
  }

  get incidentId(): string {
    return this.getAttribute('data-incident-id') || '';
  }

  set incidentId(incidentId: string) {
    this.setAttribute('data-incident-id', incidentId);
  }
}
